module.exports = __webpack_public_path__ + "img/CAST证书_01.1e4959e5.png";